import React from "react";
import "./TrustSectorsSection.css";

const sectors = [
  "Corporate Offices",
  "Industrial Plants",
  "Manufacturing Units",
  "Warehouses & Logistics Parks",
  "Residential Societies",
  "Guest Houses",
  "Hospitals & Clinics",
  "Retail Stores",
  "Institutions & Training Centers",
];

export default function TrustSectorsSection() {
  return (
    <section className="sectors-section">
      <div className="sectors-header">
        <h2>Trusted Across Sectors</h2>
        <p>Serving diverse industries with excellence</p>
      </div>

      <div className="sectors-wrapper">
        {sectors.map((item, index) => (
          <div className="sector-pill" key={index}>
            {item}
          </div>
        ))}
      </div>
    </section>
  );
}
